<template>
  <!-- メインコンテンツエリア -->
  <main class="l-main">
    <div class="l-main-content">
      <div class="p-login">
        <!-- ロゴ -->
        <login-logo />
        <!-- /ロゴ -->
        <pass-update-form />
        <!-- コピーライト -->
        <login-copyright />
        <!-- /コピーライト -->
      </div>
    </div>
  </main>
<!-- /メインコンテンツエリア -->
</template>

<script>
import 'axios';
export default {
  mounted: function () {
    import('../../funcs/pages/login-pass-update').then(module => {
      module.LoginPassUpdate();
    });
  },
}
</script>
